import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PinkGradientButton from '../../UIControls/PinkGradientButton';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import BriefcaseIcon from '../../../assets/icons/Briefcase.svg';
import ClinicIcon from '../../../assets/icons/Clinic.svg';
import subscriptionPlans from './subscriptionPlans';

const SettingsSubscription = ({ plan, sectionSx = {}, canManagePlan = true }) => {
    const navigate = useNavigate();

    const formatPlanName = (plan) => {
        if (!plan) return '';
        // Capitalize the first letter and lowercase the rest
        return plan.charAt(0).toUpperCase() + plan.slice(1).toLowerCase();
    };

    const formattedPlan = formatPlanName(plan);
    const normalizedPlan = formattedPlan === 'Pro' ? 'Professional' : formattedPlan || 'Free';
    const planConfig = subscriptionPlans?.[normalizedPlan];
    const planDescription = subscriptionPlans?.[normalizedPlan]?.description || '';
    const monthlyValue = typeof planConfig?.priceMonthly === 'number' ? planConfig.priceMonthly : 0;
    const monthly = `£${monthlyValue.toFixed(2)}`;
    const isProfessionalPlan = normalizedPlan === 'Professional';
    const PlanIcon = {
        Free: LockOpenOutlinedIcon,
    }[normalizedPlan];
    const isClinicPlan = normalizedPlan === 'Clinic';
    return (
        <Box
            className="settings-block"
            sx={{
                backgroundColor: 'white',
                border: '1px solid rgba(102, 102, 102, 0.15)',
                borderRadius: '30px',
                padding: { xs: '20px 22px', md: '24px 30px' },
                my: 3,
                ...sectionSx,
            }}
        >
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 600, height: 48 }}>
                    Subscription
                </Typography>
            </Box>

            <Box sx={{ mt: 2, background: '#F0F0FC', borderRadius: '14px', p: 2 }}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '10px',
                        border: '1px solid rgba(255, 102, 155, 0.35)',
                        background: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1,
                    }}
                >
                    {isProfessionalPlan ? (
                        <Box component="img" src={BriefcaseIcon} alt="Briefcase" sx={{ width: 20, height: 20 }} />
                    ) : isClinicPlan ? (
                        <Box component="img" src={ClinicIcon} alt="Clinic" sx={{ width: 20, height: 22 }} />
                    ) : PlanIcon ? (
                        <PlanIcon sx={{ color: '#FF669B', fontSize: 20 }} />
                    ) : (
                        <Box component="img" src={BriefcaseIcon} alt="Briefcase" sx={{ width: 20, height: 20 }} />
                    )}
                </Box>
                <Typography sx={{ color: '#000453', fontWeight: 700, fontSize: 38, lineHeight: 1 }}>
                    {normalizedPlan}
                </Typography>
                {planDescription && (
                    <Typography
                        sx={{
                            color: '#616063',
                            fontFamily: 'Inter',
                            fontSize: { xs: '12px', md: '16px' },
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: { xs: '16px', md: '24px' },
                            letterSpacing: { xs: '-0.24px', md: 'normal' },
                            overflow: { xs: 'visible', md: 'hidden' },
                            textOverflow: { xs: 'clip', md: 'ellipsis' },
                            mt: 1,
                            maxWidth: 760,
                        }}
                    >
                        {planDescription}
                    </Typography>
                )}
                <Box sx={{ mt: 2, display: 'flex', alignItems: 'flex-end', gap: 1 }}>
                    <Typography sx={{ color: '#000453', fontWeight: 700, fontSize: 34, lineHeight: 1 }}>
                        {monthly}
                    </Typography>
                    <Typography sx={{ color: '#616063', fontSize: 14, mb: 0.5 }}>/month</Typography>
                </Box>
            </Box>
            {canManagePlan && (
                <PinkGradientButton
                    sx={{
                        display: 'flex',
                        width: { xs: '100%', md: '962px' },
                        height: '44px',
                        padding: '15px 20px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        borderRadius: '200px',
                        background: '#FF669B',
                        backgroundImage: 'none',
                        '&:hover': { background: '#FF85B0', backgroundImage: 'none' },
                        mt: 2,
                        maxWidth: '100%',
                    }}
                    className="black-btn"
                    onClick={() => navigate('/settings/manage-subscription')}
                >
                    Manage current plan
                </PinkGradientButton>
            )}
        </Box>
    );
};

export default SettingsSubscription;
